var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNameIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18.796,
    fill: "#59A3CF",
    r: 5.084
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.943,25.688H17.056c-0.904,0-1.638,0.733-1.638,1.638v10.337c2.501,1.554,5.443,2.467,8.605,2.467    c3.142,0,6.066-0.902,8.559-2.439V27.326C32.582,26.422,31.848,25.688,30.943,25.688z",
    fill: "#59A3CF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.745,0,0,10.745,0,24s10.745,24,24,24s24-10.745,24-24S37.255,0,24,0z M24.029,43.844   c-11.023,0-19.959-8.936-19.959-19.959S13.006,3.926,24.029,3.926s19.959,8.936,19.959,19.959S35.052,43.844,24.029,43.844z",
    fill: "#59A3CF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIconActive);
export default __webpack_public_path__ + "static/media/name-icon-active.b8d33cbd0af7d47e9846ab98a51d3b6d.svg";
export { ForwardRef as ReactComponent };